<template>
  <v-footer
    v-if="!isUserLoggedIn()"
    location="bottom"
    :app="true"
    variant="dense"
  >
    <v-row justify="space-between">
      <v-col cols="8">
        <span class="footertext"
          >{{ $t('footer.notloggedin') }} {{ getEnv() }}</span
        >
      </v-col>

      <div class="footertext locale">
        {{ $i18n.locale }}
      </div>
    </v-row>
  </v-footer>
  <v-footer
    v-else
    bottom
    app
    padless
    dense
    tile
    hide-on-scroll
    color="var(--color-brand-200)"
  >
    <!-- IS AUTHENTICATED -->
    <v-toolbar-items>
      <v-btn text>
        <span class="footertext"> &copy; v{{ getEnv() }}</span>
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-items>
      <v-btn text>
        <span class="footertext nametext">
          {{ loggedInAs() }}
        </span>
      </v-btn>
    </v-toolbar-items>
    <v-spacer />
  </v-footer>
</template>

<script>
import adminStore from '@/stores/adminstore'
import userStore from '@/stores/userstore'
import { mapActions, mapState, mapGetters } from 'pinia'

import app from '../../../package.json'

export default {
  name: 'FooterMenu',
  // props: ['auth', 'authenticated'],
  data() {
    return {
      svgs: {
        nb: '/svgs/nb.svg',
        en: '/svgs/en.svg'
      }
    }
  },
  mounted() {},
  beforeMount() {
    console.log(this.$i18n.locale)
    let webLang = get3DigitLangCode(this.$i18n.locale)
    console.log('=== WEB LANG === (%o)', webLang)
    this.setLang(webLang)
    localStorage.setItem('lang', webLang)
    this.$date.locale(this.$root.$i18n.locale)
  },
  methods: {
    ...mapActions(adminStore, ['setLang']),
    ...mapGetters(adminStore, ['getEnvironment', 'getDisplayName']),
    ...mapGetters(userStore, ['isUserLoggedIn', 'getPnr']),
    loggedInAs() {
      var displayName = this.getDisplayName() || this.getPnr()
      if (this.isUserLoggedIn()) {
        return displayName || 'no id'
      }
      return '[NOT LOGGED IN]'
    },
    getEnv() {
      return app.version
    }
  }
}

function get3DigitLangCode(lang2) {
  switch (lang2.toLowerCase()) {
    case 'nb':
      return 'nob'
    case 'nn':
      return 'nno'
    case 'en':
      return 'eng'
    /* case 'no':
      return 'nob' // 'nor'
      */
    case 'se':
      return 'sme'
    default:
      return 'nob'
  }
}
</script>

<style lang="css">
.footertext {
  color: var(--color-white);
  font-size: 0.7rem;
}

.footer {
  text-align: left;
  font-size: calc(0.6em + 1vmin);
  color: rgb(100, 100, 100);
}

.footerinfo {
  text-align: left;
  font-size: calc(0.6em + 1vmin);
  margin-left: 10px;
  margin-right: 10px;
  color: rgb(100, 100, 100);
}

.languagechooser {
  text-align: left;
  font-size: calc(0.6em + 1vmin);
  margin-left: 20px;
  color: rgb(100, 100, 100);
}

.hostinfo {
  padding-left: 20px;
  text-align: left;
  font-size: calc(0.6em + 0.7vmin);
  color: rgb(100, 100, 100);
}

.domainserver {
  padding-left: 10px;
  font-size: calc(0.3em + 0.3vmin);
  color: rgb(100, 100, 100);
}

.nametext {
  font-size: 0.8rem;
  font-weight: 300;
  text-transform: capitalize;
}

.locale {
  padding-right: 2vw;
}
</style>
